@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}

@if(isLoading) {
  <div class="text-center">
    <p>Loading payload data...</p>
  </div>
} @else {
  <h1 data-automation-name="payloadView">
    <span>Viewing {{payload.id}}</span>
  </h1>

  <div class="container-fluid">
    <div class="row"><label>Payload ID:</label> {{payload.id}}</div>
    <div class="row"><label>VEN ID:</label> {{payload.ven_id}}</div>
    <div class="row"><label>Request ID:</label> {{payload.request_id}}</div>
    <div class="row"><label>Sent type:</label> {{payload.sent_type}}</div>
    <div class="row"><label>Sent time:</label> {{payload.sent_dttm}}</div>
    <div class="row"><label>Received type:</label> {{payload.received_type}}</div>
    <div class="row"><label>Received time:</label> {{payload.received_dttm}}</div>

    <div class="row">
      <label>Sent body:</label>
      <blockquote class="blockquote" style="height: 500px">
        <textarea readonly [(ngModel)]="payload.sent_body" class="form-control" style="height: 100%; font-family: monospace;"></textarea>
      </blockquote>
    </div>

    <div class="row">
      <label>Received body:</label>
      <blockquote class="blockquote" style="height: 500px">
        <textarea readonly [(ngModel)]="payload.received_body" class="form-control" style="height: 100%; font-family: monospace;"></textarea>
      </blockquote>
    </div>

    <div class="row" style="margin-top: 20px">
      <button class="btn btn-default" (click)="back()">Back to Payloads</button>
    </div>
  </div>
}
